import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "bead-root" }
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "43",
  height: "43",
  viewBox: "0 0 43 43",
  class: "svg"
}
const _hoisted_3 = {
  id: "Group_42",
  "data-name": "Group 42",
  transform: "translate(-13 -749)"
}
const _hoisted_4 = {
  key: 0,
  id: "Ellipse_27",
  "data-name": "Ellipse 27",
  transform: "translate(13 749)",
  fill: "#ff3d3d",
  stroke: "#fff",
  "stroke-width": "3"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("circle", {
  cx: "6.5",
  cy: "6.5",
  r: "6.5",
  stroke: "none"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("circle", {
  cx: "6.5",
  cy: "6.5",
  r: "5.5",
  fill: "none"
}, null, -1)
const _hoisted_7 = {
  key: 1,
  id: "Ellipse_28",
  "data-name": "Ellipse 28",
  transform: "translate(43 779)",
  fill: "#2945ff",
  stroke: "#fff",
  "stroke-width": "3"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("circle", {
  cx: "6.5",
  cy: "6.5",
  r: "6.5",
  stroke: "none"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("circle", {
  cx: "6.5",
  cy: "6.5",
  r: "5.5",
  fill: "none"
}, null, -1)
const _hoisted_10 = {
  id: "闲",
  fill: "#fff",
  "font-size": "23",
  x: "50%",
  y: "50%",
  "dominant-baseline": "middle",
  "text-anchor": "middle",
  "font-weight": "200"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock("svg", _hoisted_2, [
      _createVNode("g", _hoisted_3, [
        _createVNode("circle", {
          id: "Ellipse_26",
          "data-name": "Ellipse 26",
          cx: "21.5",
          cy: "21.5",
          r: "21.5",
          transform: "translate(13 749)",
          fill: _ctx.fillColor
        }, null, 8, ["fill"]),
        (_ctx.hasRedpair)
          ? (_openBlock(), _createBlock("g", _hoisted_4, [
              _hoisted_5,
              _hoisted_6
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasBluePair)
          ? (_openBlock(), _createBlock("g", _hoisted_7, [
              _hoisted_8,
              _hoisted_9
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("text", _hoisted_10, _toDisplayString(_ctx.isSuper6 ? '6' : _ctx.label), 1)
    ]))
  ]))
}